const wrapper = "_mwwtfw1d7";
const heading = "_mwhr9509o";
const header = "_mwhyohp2t";
const elementToolbarPlaceholder = "_mweypu63i";
const contentWrapper = "_mwc8tj5gi";

export { contentWrapper, elementToolbarPlaceholder, header, heading, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
